<template>
  <v-card
    class="libraryApp"
    :class="getClassNames()"
  >
    <v-row
      class="libraryApp-header"
      justify="center"
    >
      <v-col
        cols="5"
        sm="5"
        class="pa-0 text-center col-xs-3"
      >
        <v-img
          v-if="libraryApp.iconUrl"
          :aspect-ratio="1/1"
          :src="libraryApp.iconUrl"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-3"
              />
            </v-row>
          </template>
        </v-img>
        <v-icon
          v-else
          class="default-icon"
        >
          mdi-application
        </v-icon>
      </v-col>
      <v-col cols="12">
        <h2 class="text-center">
          {{ libraryApp.name }}
        </h2>
      </v-col>
      <v-col class="description text-justify px-lg-3 px-md-0 px-3">
        <span>
          {{ libraryApp.title | truncate(maxTitleLength) }}

          <span v-if="libraryApp.title.length>maxTitleLength">
            ..
            <a
              class="card-description-more"
              @click="activateReadMore()"
            >
              {{ $t('vehicle_details.txt.more') }}
            </a>
          </span>

          <v-dialog
            v-model="isDialogVisible"
            max-width="600"
            content-class="more-dialog"
            @click="isDialogVisible = !isDialogVisible"
          >
            <v-card class="dialog-card">
              <div class="dialog-card-header">
                <v-img
                  v-if="libraryApp.iconUrl"
                  :src="libraryApp.iconUrl"
                  width="30"
                  class="dialog-card-header-icon"
                />
                <h2>{{ libraryApp.name }}</h2>
                <v-btn
                  icon
                  class="dialog-card-header-close"
                  @click="
                    isDialogVisible = !isDialogVisible
                  "
                >
                  <v-icon
                    width="18"
                    color="reddish"
                  >
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
              <div class="dialog-card-content">
                <div v-html="libraryApp.title" />
              </div>
            </v-card>
          </v-dialog>
        </span>
      </v-col>
    </v-row>

    <div
      class="libraryApp-footer"
    >
      <v-row>
        <v-col
          cols="12"
          class="px-2 py-0"
        >
          <v-btn
            depressed
            large
            class="add-athlete"
            :class="libraryApp.isActive ? 'enabled' : 'disabled'"
            @click="handleAction"
          >
            {{ $t(actionText) }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppLibraryCard',
  props: {
    libraryApp: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isChosen: !!this.libraryApp.isChosen,
      isDialogVisible: false,
      maxTitleLength: 40
    }
  },
  computed: {
    ...mapState('account', ['currency', 'accountInformation']),
    ...mapState('trucks', ['trucks']),
    actionText() {
      if (this.isChosen) {
        return this.libraryApp.isActive
          ? 'appLibrary_overview.txt.apps_deactivate'
          : 'appLibrary_overview.txt.apps_activate'
      }

      return this.libraryApp.isActive
        ? 'appLibrary_overview.txt.apps_active'
        : 'appLibrary_overview.txt.apps_inactive'
    }
  },
  methods: {
    handleAction() {
      this.libraryApp.isChosen = this.isChosen = !this.isChosen

      this.$emit('toggleSelection', this.libraryApp)
    },
    getClassNames() {
      const classNames = []

      if (this.libraryApp.isActive) {
        classNames.push('active')
      } else {
        classNames.push('inactive')
      }

      if (this.isChosen) {
        classNames.push('chosen')
      }
      return classNames
    },
    activateReadMore() {
      this.isDialogVisible = true
    }
  }
}
</script>

<style lang="scss">
.libraryApp {
  padding: 16px 32px 80px;
  height: 100%;
  vertical-align: bottom;
  border-radius: 8px !important;
  box-shadow: 0 1px 2px 0 #00000033;

  .default-icon {
    font-size: 80px;
    color: var(--v-cloudy-base);
  }

  &-header {
    h2 {
      font-weight: bold;
      font-size: 1.25rem;
      color: var(--v-slate-base);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      font-size: 0.875rem;
      color: var(--v-bluegrey-base);
    }
    .description {
      font-size: 1rem;
      color: var(--v-slate-base);
      line-height: 1.25;
    }
  }
  &-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px;
    background-color: var(--v-pale-two-base);
    font-size: 1rem;
    color: var(--v-slate-base);

    span {
      font-size: 0.75rem;
    }

    .label {
      font-size: 0.75rem;
      font-weight: bold;
      text-transform: uppercase;
      color: var(--v-bluegrey-base);
    }

    .add-athlete {
      height: 64px !important;
      width: 100%;

      span {
        font-size: 1.125rem;
        font-weight: bold;
        color: white;
      }
      &.enabled {
        background-image: linear-gradient(to bottom, #266cab 0%, #01529c);
      }
      &.disabled {
        background-color: var(--v-cloudy-base) !important;
        background-image: none;
      }
    }

    .status-label {
      font-size: 1rem;
      font-weight: bold;
    }
  }
  &.active {
    --glow-color: rgba(19, 98, 167, 0.2);
    -webkit-box-shadow: 0px 3px 5px -1px var(--glow-color),
      0px 5px 8px 0px var(--glow-color), 0px 1px 14px 0px var(--glow-color) !important;
    box-shadow: 0px 3px 5px -1px var(--glow-color),
      0px 5px 8px 0px var(--glow-color), 0px 1px 14px 0px var(--glow-color) !important;
    &.chosen {
      --glow-color: rgba(192, 80, 5, 0.418);
      -webkit-box-shadow: 0px 3px 5px -1px var(--glow-color),
        0px 5px 8px 0px var(--glow-color), 0px 1px 14px 0px var(--glow-color) !important;
      box-shadow: 0px 3px 5px -1px var(--glow-color),
        0px 5px 8px 0px var(--glow-color), 0px 1px 14px 0px var(--glow-color) !important;

      .add-athlete {
        background-image: linear-gradient(
          to bottom,
          var(--glow-color) 0%,
          var(--glow-color)
        );
      }
    }
  }
  &.inactive {
    &.chosen {
      --glow-color: rgba(5, 192, 14, 0.418);
      -webkit-box-shadow: 0px 3px 5px -1px var(--glow-color),
        0px 5px 8px 0px var(--glow-color), 0px 1px 14px 0px var(--glow-color) !important;
      box-shadow: 0px 3px 5px -1px var(--glow-color),
        0px 5px 8px 0px var(--glow-color), 0px 1px 14px 0px var(--glow-color) !important;

      .add-athlete {
        background-image: linear-gradient(
          to bottom,
          var(--glow-color) 0%,
          var(--glow-color)
        );
      }
    }
  }
}
</style>